import React from 'react';
import Back from '../../components/Back';
import DocList from '../Doc/List';

export const MaterialDetail = ({match}) => {
  return (
    <div className="container py-4">
      <Back />
      <div className="mt-4">
        <DocList materialId={match.params.id} />
      </div>
    </div>
  );
};

export default MaterialDetail;
